import React, { useState, useEffect } from "react";
import axios from 'axios';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import Pagination from "react-js-pagination";
import pagiarray from 'paginate-array';
import Filter from '../util/Filter';
import { BellOutlined, FileExcelOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import Select from 'react-select';
import "antd/dist/antd.css";
import moment from 'moment';
import { CSVLink } from 'react-csv';
import {
    DatePicker, Space, Table, Row, Col, Modal,Input, Button, Tooltip
} from 'antd';
import pr from "../util/pr";
import GetApiHost from '../util/GetApiHost';

const { TextArea } = Input;

const SendArea = styled.div`
    padding-top:15px;
`;

const SendButton = styled.div`
    padding-top:15px;
`;

const SendName = styled.div`
    padding-top:5px;
`;

const columns = [
    {
        title: '이름',
        dataIndex: 'name',
        key: 'name',
        width: 160,
    },
    {
        title: '연락처',
        dataIndex: 'hp',
        key: 'hp',
        width: 160,
    },
    {
        title: '시작일',
        dataIndex: 'sdate',
        key: 'sdate',
    },
    {
        title: '종료일',
        dataIndex: 'edate',
        key: 'edate',
    }
];

const SelectStyle = styled(Select)`
    width:250px;
`

const TableContainer = styled.div`
    width:800px;
`

export default function Teacher() {
    const [teacher, setTeacher] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    const [centers, setCenters] = useState([]);
    const [tdate, setTDate] = useState(moment().format('YYYY-MM-DD'));
    const [cid, setCID] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const api_host = GetApiHost();
    const token = localStorage.getItem('refresh_token');
    const [message, setMessage] = useState('');
    const [sendName, setSendName] = useState('');

    const send_click = async () => {
        let result = await axios.post(api_host+'/push/all_now',{
            token:token,
            title:'알림',
            cid:cid,
            count:count,
            message:message,
            send_name: sendName,
            tdate:tdate
        });
        if(result.data.ret==='N')
        {
            alert(result.data.msg);
            return;
        }
        else 
        {
            setMessage('');
            setSendName('');
            setModalVisible(false);
            alert('전송되었습니다.');
        }
    }    

    // 지점별 CID 고정
    useEffect(() => {
        if (data.cid !== '') {
            if (data.level !== 500) {
                setCID(data.cid);
            }
        }
    }, [data.cid]);

    // 센터목록 셀랙트 박스
    const getCenterList = async () => {
        let result;
        let rows = [];
        result = await axios.post(data.url + "/slim/center_list", {
            sid: 'smartgym'
        });
        result.data.map((n, i) => {
            rows.push({
                value: n.cid,
                label: n.center + ' ' + n.location
            })
        });
        setCenters(rows);
    }

    // 이용중인 회원
    const getSmsList = async () => {

        let rows = [];
        let result;
        let token = localStorage.getItem('refresh_token');
        result = await axios.post(api_host+'/sp/get_enter_member', {
            token: token,
            cid: cid,
            tdate: tdate
        });
        if (result.data.length > 0) {
            result.data.map((n, i) => {
                rows.push({
                    key: i,
                    name: n.name,
                    hp: n.hp,
                    sdate: moment(n.sdate).format('YYYY-MM-DD'),
                    edate: moment(n.edate).format('YYYY-MM-DD')
                })
            });
            setDataSource(rows);
        }
        setCount(result.data.length);        
    }

    const on_change_date = value => {
        setTDate(moment(value).format('YYYY-MM-DD'));
    }

    const on_change_center = event => {
        setCID(event.value);
    }

    const on_search = async () => {
        setDataSource([]);
        await getSmsList();
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if (result === "Y") {
            const decodeResult = await DecodeData(data.url);
            dispatch({ type: 'SET', name: "CID", value: decodeResult.cid });
            dispatch({ type: 'SET', name: "LEVEL", value: decodeResult.level });
        } else {
            LoginFail();
        }
        await getCenterList();
    }

    useEffect(() => {
        main();        
    }, []);

    const send_push_modal = () => {
        setModalVisible(true);
    }

    const close_modal = () => {
        setModalVisible(false);        
    }

    return (
        <main className="main-container">

            <TopNav />
            <div className="content-wrapper">
                <MainNav />

                <Modal title="푸시 발송하기"
                    // onOk={}
                    onCancel={() => close_modal()}
                    visible={modalVisible}
                    footer={[]}
                >
                    <div>
                        <div>발송대상 : {count} 명</div>
                        <SendArea>
                           <TextArea rows={5} onChange={e=>setMessage(e.target.value)} value={message}>
                           </TextArea>
                        </SendArea>
                        <SendName>
                            발송자명 <Input style={{ width:90 }} onChange={e=>setSendName(e.target.value)} value={sendName}></Input>
                        </SendName>
                        <SendButton>
                            <Button type="primary" onClick={()=>send_click()}>발송하기</Button>
                        </SendButton>
                    </div>
                </Modal>

                <div className="content-inner">
                    <h3 style={{ display: "inline-block" }}>이용중인 회원</h3>

                    <div className="content-component">
                        <Row style={{ width: "800px" }}>
                            <Col >선택 : {count}명</Col>
                        </Row>
                        
                        <Row align="middle" justify="end" style={{maxWidth:800}}>
                            <Col>
                                <CSVLink
                                    data={dataSource}
                                    filename={"data.csv"}
                                ><Button type="danger"> <FileExcelOutlined /> 엑셀저장</Button>
                                </CSVLink>
                            </Col>                            
                            <Col style={{ marginLeft:5 }}>                                
                                <Button type="primary" onClick={() => send_push_modal()}> <BellOutlined /> 푸시발송</Button>                                
                            </Col>
                            <Col style={{ paddingLeft: 5 }}>
                                <Tooltip placement="top" title="기준일자">
                                    <DatePicker
                                    format="YYYY-MM-DD" 
                                    onChange={on_change_date}
                                    defaultValue={moment(moment(),'YYYY-MM-DD')}
                                    >
                                    </DatePicker>
                                </Tooltip>
                                </Col>
                            <Col style={{ paddingLeft: 5 }}>
                                {data.level === 500 ?
                                    <SelectStyle
                                        placeholder="센터 선택"
                                        options={centers}
                                        onChange={on_change_center}
                                    >
                                    </SelectStyle> : null}
                            </Col>
                            <Col style={{ paddingLeft: 5 }}>
                                <Button onClick={on_search}>조회</Button>
                            </Col>
                        </Row>

                        <div className="content-body">
                            <TableContainer>
                                <Table dataSource={dataSource} columns={columns}
                                    pagination={{
                                        pageSizeOptions: []
                                    }}
                                >
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

